import styles from './ProgramNonMemberModal.module.scss';
import box from '../../assets/question/box.png';
import { useNavigate } from 'react-router-dom';
import { isDesktop } from 'react-device-detect';
import { useEffect } from 'react';

function ProgramNonMemberModal({ closer }: any) {
  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  return (
    <>
      <div
        className={`${styles.modalContainer} ${
          !isDesktop ? styles.isMobile : ''
        }`}
      >
        <div className={styles.modalWrap}>
          <div className={styles.textWrap}>
            <span>로그인이 필요한 서비스입니다.</span>
            <span>로그인하시겠습니까?</span>
          </div>
          <div className={styles.btnWrap}>
            <div
              onClick={() => {
                closer(false);
              }}
            >
              아니오
            </div>
            <div
              onClick={() => {
                window.location.href = `/login?rurl=${
                  window.location.pathname + window.location.search
                }`;
              }}
            >
              예
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProgramNonMemberModal;
